import React from "react"
import { OperationSaleListPage } from "./OperationSaleListPage"

export const OperationPostReceiptPage: React.FC = () => (
 <OperationSaleListPage
 operationalStage="post_receiving"
 titleKey="operation.postReceipt.title"
 subtitleKey="operation.postReceipt.subtitle"
 progressStageKey="pos_recebimento"
 getSaleDetailPath={(saleId) => `/operation/preparation/${saleId}`}
 />
)
